import SecureAPI from '../services/api/SecureAPI';

class BaseModel extends SecureAPI {

    static STATUS_SUCCESS = "SUCCESS";

    constructor() {
        super(false);
    }

    async getData(entityName, params = {}) {
        return await this.get(entityName, params);
    }

    async saveData(entityName, params = {}) {
        return await this.post(entityName, params);
    }

    async postData(entityName, params = {}) {
        return await this.post(entityName, params);
    }

    async removeData(entityName, params = {}) {
        return await this.delete(entityName, params);
    }
}

export default BaseModel;